import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatampelComponent } from './chatampel.component';
import { AngularMaterialModule } from '../../material.module';

@NgModule({
    declarations: [ChatampelComponent],
    imports: [
        CommonModule,
        AngularMaterialModule
    ],
    exports: [
        ChatampelComponent
    ]
})
export class ChatampelModule { }
